<template>
    <div>
        <user-creation-modal modal-id="userCreationModal"
            modal-title="Ajouter un utilisateur"
            v-if="userCreationModalDisplayed"
            @modal-closed="onUserCreationModalClosed"
        >
            <user-creation-form @user-created="onUserCreated">
            </user-creation-form>
        </user-creation-modal>

        <div class="list-container">
            <div class="content-overlay" v-show="isLoading"></div>

            <div class="row m-t-30">
                <div class="filters-container col-md-9">
                    <text-input :field="searchFieldConfig"
                        :value="searchValue"
                        :field_idx="searchFieldConfig.idx"
                        @field-updated="onSearchFieldUpdate">
                    </text-input>
                </div>

                <div class="col-md-3">
                    <button class="btn btn-primary btn-block" @click="userCreationModalDisplayed = true">Ajouter un utilisateur</button>
                </div>
            </div>

            <template v-if="users.length > 0">
                <users-table :users="users"
                    @user-name-updated="onUserNameUpdate"
                    @user-phone-updated="onUserPhoneUpdate"
                    @user-email-updated="onUserEmailUpdate"></users-table>

                <pagination :current-page="currentPage"
                    :total-pages="lastPage"
                    @click="onPaginationClick">
                </pagination>

                <div class="clearfix"></div>
            </template>

            <div v-else class="alert alert-info m-t-30">
                Aucun résultat correspondant.
            </div>
        </div>
    </div>
</template>

<script>
    import UserCreationModal from 'components/Modals/FillInModal'
    import CustomerDissociationModal from 'components/Modals/SlideUpModal'
    import UserCreationForm from 'components/Users/UserCreationForm'
    import TextInput from 'components/Forms/Elements/Text'
    import UsersTable from 'components/Users/UsersTable'
    import Pagination from 'components/Pagination'

    export default {
        data() {
            return {
                userType: 'buyer',
                currentPage: 0,
                lastPage: 0,
                users: [],
                userCreationModalDisplayed: false,
                isLoading: false,
                searchValue: ''
            }
        },

        components: {
            UserCreationModal,
            CustomerDissociationModal,
            UserCreationForm,
            TextInput,
            UsersTable,
            Pagination
        },

        created() {
            this.debouncedGetUsers = _.debounce(this.getUsers, 750)
        },

        mounted() {
            this.getUsers()
        },

        computed: {
            searchFieldConfig() {
                return {
                    placeholder: "Filtrez les résultats (3 caractères minimum)",
                    disabled: false,
                    idx: 1,
                    required: false,
                    value: this.searchValue,
                    label: "",
                    type:"text"
                }
            }
        },

        methods: {
            onUserCreationModalClosed() {
                this.userCreationModalDisplayed = false
            },

            onUserCreated() {
                this.getUsers()
            },

            getUsers() {
                this.isLoading = true

                const params = {
                    type: this.userType,
                    page: this.currentPage + 1,
                    orderBy: 'id',
                    sortedBy: 'desc'
                }

                if (this.searchValue.length > 0) {
                    params.search = this.searchValue
                }

                this.$root.axios.get(`users`, {params})
                    .then(response => {
                        this.users = response.data.data
                        this.lastPage = response.data.last_page
                        this.isLoading = false
                    })
            },

            onSearchFieldUpdate(event) {
                const search = event.new_value

                this.searchValue = search

                if (search.length == 0 || search.length > 2) {
                    this.debouncedGetUsers()
                }
            },

            onPaginationClick(selectedIndex) {
                this.currentPage = selectedIndex
            },

            onUserNameUpdate(userIdObject) {
                this.getUsers()
            },

            onUserPhoneUpdate(userIdObject) {
                this.getUsers()
            },
            
            onUserEmailUpdate(userIdObject) {
                this.getUsers()
            }
        },

        watch: {
            currentPage(oldValue, newValue) {
                this.getUsers()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list-container {
        position: relative;
    }

    .content-overlay {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
        z-index: 999;
    }
</style>



// WEBPACK FOOTER //
// client/views/Users/UsersList.vue